
let config;


if (process.env.NODE_ENV === "production") {
    config = {
        status: false,
        api_url: location.origin,
        timeoutDuration: 30000,
        someOtherProps: 'xyz',
        client_id: 'e8bc612a-d689-4890-9cc7-0bbb084a172a',
        client_secret: 'Yhuiw34y7890xc',
        recaptcha_secret: '6LcQUXIUAAAAANVm0-6RzE-G9ylF-YUzl3CFhVeQ',
        live_url:  'https://luvnotes-d8.pantheonlocal.com/lnotes/sign-in#/',

        apiUrl:  'https://zapi.digirize.com',
        auth_username: 'restuser',
        auth_password: 'RU#1gohome1'

    };

} else {
    //axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
    config = {
        status: true,
        //   token : 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE1OTg5ODY1MzksImV4cCI6MTU5ODk5MDEzOSwiZHJ1cGFsIjp7InVpZCI6IjEifX0.DXirL5PJdX43Q-mnneP9zFkq3tOtxFMlSa-s8hJy2bTkq-crxo9QH9O2hRH-NtDI8EHvrA81VrTsUzUuaXA1txPIIqQqE7YOOWMgiKn9Fo1tw7yC6aVCpzeajvhCLK3hoNdWXhIfMPy3zHfd7QTyUSgUN2pu8WeXVyBEPmBE7C8qBJiijbp_-aEadMZonFe0JWtGb9U9ml1AYACP0W39f0tMgCdRmXOd8hUtPUg6U2HiWXGBRpnzc_K--hJFpMdmU8hlLwoQFT2MIkVBoTY8F-afz2JLF1SZQ9188st_WoMNlQBEREdb-6WNqFt3UYVjh46fmZ8439jyVcw-nMmNww',
        //    token : '',
        authvalue : 'Bearer ',
        api_url: "https://luvnotes-d8.pantheonlocal.com",
        timeoutDuration: 1000,
        someOtherProps: 'abc',
        client_id: 'e8bc612a-d689-4890-9cc7-0bbb084a172a',
        client_secret: 'Yhuiw34y7890xc',
        recaptcha_secret: '6LcQUXIUAAAAANVm0-6RzE-G9ylF-YUzl3CFhVeQ',
        live_url: '/#/',
        apiUrl:  'https://zapi.digirize.com',
        auth_username: 'restuser',
        auth_password: 'RU#1gohome1'
    };
}

export { config }


